import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./components/App/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { OvertimeProvider } from "./contexts/OvertimeContext";
import { registerServiceWorker } from "./config/firebase";
import { installNumberInputWheelGuard } from "./utils/disableNumberInputWheel";

installNumberInputWheelGuard();

// Автоматически регистрируем Service Worker при загрузке приложения
if ("serviceWorker" in navigator) {
  registerServiceWorker().catch((error) => {
    console.error("Ошибка регистрации Service Worker при загрузке:", error);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <OvertimeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </OvertimeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
